export default {
    props: ["paymentMethod"],
    data() {
      return {
          showStripe: true,
          showApplePay: false
      }
    },
    mounted() {
        this.loadStripe();
    },
    methods: {
        loadStripe: function () {
            let stripe = Stripe(this.paymentMethod.form.key);
            const elements = stripe.elements();
            const style = {
                base: {
                    fontSize: '16px',
                    color: '#32325d'
                },
            };
            const card = elements.create('card', {style});
            card.mount('#card-element');

            this.loadApplePay(stripe, elements);

            const form = document.getElementById('payment-form-stripe');
            let isSubmitting = false;
            form.addEventListener('submit', async (event) => {
                event.preventDefault();
                if(isSubmitting){
                    return;
                }
                isSubmitting = true;
                const {token, error} = await stripe.createToken(card);
                if (error) {
                    isSubmitting = false;
                    const errorElement = document.getElementById('card-errors');
                    errorElement.textContent = error.message;
                } else {
                    this.stripeTokenHandler(token);
                }
            });
        },
        // Apple Pay: aether manda form.apple_pay ({amount, label}) solo si el método lo ofrece.
        // El botón sale únicamente en Safari con una tarjeta en la Wallet y en un dominio
        // registrado en Stripe. Devuelve un token como el de la tarjeta, así que el cobro es el mismo.
        loadApplePay: function (stripe, elements) {
            const applePay = this.paymentMethod.form.apple_pay;
            if (!applePay) {
                return;
            }

            const paymentRequest = stripe.paymentRequest({
                country: 'ES',
                currency: 'eur',
                total: {label: applePay.label, amount: applePay.amount},
                disableWallets: ['googlePay', 'link']
            });

            paymentRequest.canMakePayment().then((result) => {
                if (!result || !result.applePay) {
                    return;
                }

                elements.create('paymentRequestButton', {paymentRequest}).mount('#payment-request-button');
                this.showApplePay = true;
            });

            // El cobro se hace al enviar el formulario, que navega a la página de gracias o de
            // error; la hoja de Apple Pay se cierra antes porque la página ya no vuelve aquí.
            paymentRequest.on('token', (event) => {
                event.complete('success');
                this.stripeTokenHandler(event.token);
            });
        },
        stripeTokenHandler: function (token) {

            let form = document.getElementById('final-form');
            form.action = this.paymentMethod.form.action;

            let hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', 'stripeToken');
            hiddenInput.setAttribute('value', token.id);

            form.appendChild(hiddenInput);
            form.submit();
        }

    }
}
